import * as React from 'react'
import { connect } from "react-redux";
import {store} from "../../store"
import {
    State,
    ViolationsType
} from "../../types";
// import { BlankSlate } from "./BlankSlate";
// import { Loading } from "./Loading";
import Data from "./Data";
import "./violationsHistoryStyle.css";
import * as moment from "moment";
import {fetchViolationsHistory, sendViolationDetail} from "../../actions";
import {setSelectedItemId, setViolationListType} from "../../utils";

interface IState {
    selecteditem: string
    violationDetailStatus: boolean,
    violationTypeStatusAll: boolean,
    violationTypeStatusSeatBelt: boolean,
    violationTypeStatusCellphone: boolean,
    violationTypeStatusQueueJumping: boolean,
    violationTypeStatusRedLight: boolean,
    violationTypeStatusTrespassZebra: boolean,
    violationTypeStatusWrongTurn: boolean,
    violationTypeStatusWrongWay: boolean,
    violationTypeStatusSpeed: boolean,
    violationTypeStatusSpotSpeed: boolean,
    startTime: string,
    endTime: string,
    startDate: string,
    endDate: string,
    violationsCount: number,
    backgroundColor: string,
    currPage: number,
    prevPage: number,
}

type Props = {
    violations: ViolationsType,
    dispatch: Function
}

export const ViolationsHistory = connect((state: State) => {
    return {
        violations: state.violationHistory.violations
    }
})
(class ViolationsHistory extends React.Component<Props, IState> {
    constructor(props: Props) {
        super(props);
        this.state = {
            selecteditem: '',
            violationDetailStatus: false,
            violationTypeStatusAll: false,
            violationTypeStatusSeatBelt: false,
            violationTypeStatusCellphone: false,
            violationTypeStatusQueueJumping: false,
            violationTypeStatusRedLight: false,
            violationTypeStatusTrespassZebra: false,
            violationTypeStatusWrongTurn: false,
            violationTypeStatusWrongWay: false,
            violationTypeStatusSpeed: false,
            violationTypeStatusSpotSpeed: false,
            startDate: '',
            startTime: '',
            endDate: '',
            endTime: '',
            violationsCount : 100,
            backgroundColor: '',
            currPage:1,
            prevPage: 1,
        };
        store.subscribe(() => {
            // When state will be updated(in our case, when items will be fetched), 
            // we will update local component state and force component to rerender 
            // with new data.
            this.setState({
              currPage: store.getState().violationHistory.violationsPagination.currPage,
            })
          // window.localStorage["pageChanged"] = true;
          
          });
        this.viewSelectedViolation = this.viewSelectedViolation.bind(this);
        this.violationTypeCheckingAll = this.violationTypeCheckingAll.bind(this);
        this.violationTypeCheckingSeatBelt = this.violationTypeCheckingSeatBelt.bind(this);
        this.violationTypeCheckingCellphone = this.violationTypeCheckingCellphone.bind(this);
        this.violationTypeCheckingQueueJumping = this.violationTypeCheckingQueueJumping.bind(this);
        this.violationTypeCheckingRedLight = this.violationTypeCheckingRedLight.bind(this);
        this.violationTypeCheckingTrespassZebra = this.violationTypeCheckingTrespassZebra.bind(this);
        this.violationTypeCheckingWrongTurn = this.violationTypeCheckingWrongTurn.bind(this);
        this.violationTypeCheckingWrongWay = this.violationTypeCheckingWrongWay.bind(this);
        this.violationTypeCheckingSpeed = this.violationTypeCheckingSpeed.bind(this);
        this.violationTypeCheckingSpotSpeed = this.violationTypeCheckingSpotSpeed.bind(this);
        this.timeFilterChanged = this.timeFilterChanged.bind(this);
        this.violationsCountChanged = this.violationsCountChanged.bind(this);
        this.currPageChanged = this.currPageChanged.bind(this)
        this.getStartDate = this.getStartDate.bind(this);
        this.getEndDate = this.getEndDate.bind(this);
        this.callApiWithFilters = this.callApiWithFilters.bind(this);
    }
    async currPageChanged (){
        this.callApiWithFilters();
    }
    async violationsCountChanged(event:any) {
        if(event.target.value){
            await this.setState({violationsCount: event.target.value});

        }
        this.callApiWithFilters();

    }
    async timeFilterChanged(event: any, type: string) {
        // console.log("here", event.target.value);

        switch (type) {
            case 'dateTo':
                await this.setState({endDate: event.target.value});
                break;
            case 'dateFrom':
                await this.setState({startDate: event.target.value});
                break;
            case 'timeTo':
                await this.setState({endTime: event.target.value});
                break;
            case 'timeFrom':
                await this.setState({startTime: event.target.value});
                break;
        }

        this.callApiWithFilters();
    }

    getStartDate() {
        let startDateTime;
        if (this.state.startDate && this.state.startTime) {
            startDateTime = moment(this.state.startDate + ' ' + this.state.startTime, 'YYYY-MM-DD HH:mm').utc().valueOf();

             console.log(startDateTime);
        } else if (this.state.startDate && !this.state.startTime) {
            startDateTime = moment(this.state.startDate, 'YYYY-MM-DD').utc().valueOf();

             console.log(startDateTime);
        }

        return startDateTime;
    }

    getEndDate() {
        let endDateTime = moment().utc().valueOf();
        if (this.state.endDate && this.state.endTime) {
            endDateTime = moment(this.state.endDate + ' ' + this.state.endTime, 'YYYY-MM-DD HH:mm').utc().valueOf();

            // console.log(endDateTime);
        } else if (this.state.endDate && !this.state.endTime) {
            endDateTime = moment(this.state.endDate, 'YYYY-MM-DD').utc().valueOf();

            // console.log(endDateTime);
        }

        return endDateTime;
    }

    callApiWithFilters() {
        setViolationListType('history');
        setSelectedItemId('');
        const { dispatch } = this.props;
        if (this.state.violationTypeStatusAll) {
            dispatch(fetchViolationsHistory(this.getStartDate(), this.getEndDate(), undefined, this.state.violationsCount, this.state.currPage));

        } else {
            let violationType: string[] = [];

            if (this.state.violationTypeStatusQueueJumping) {
                violationType.push('cutlane');
            }

            if (this.state.violationTypeStatusTrespassZebra) {
                violationType.push('trespass_zebra');
            }

            if (this.state.violationTypeStatusRedLight) {
                violationType.push('runningredlight');
            }
            if (this.state.violationTypeStatusWrongTurn) {
                violationType.push('wrongturn');
            }
            if (this.state.violationTypeStatusWrongWay) {
                violationType.push('wrongway');
            }
            if (this.state.violationTypeStatusSeatBelt) {
                violationType.push('seatbelt');
            }
            if (this.state.violationTypeStatusCellphone) {
                violationType.push('cellphone');
            }
            if (this.state.violationTypeStatusSpeed) {
                violationType.push('speed');
            }
            if (this.state.violationTypeStatusSpotSpeed) {
                violationType.push('spotspeed');
            }

            dispatch(fetchViolationsHistory(this.getStartDate(), this.getEndDate(), violationType, this.state.violationsCount, this.state.currPage));
        }

        dispatch(sendViolationDetail('', ''));
    }

    viewSelectedViolation(): void {
        this.setState({
            violationDetailStatus: true,
            backgroundColor: '#000000'
        });

    }

    async violationTypeCheckingAll() {
        await this.setState({violationTypeStatusAll: !this.state.violationTypeStatusAll});
        await this.setState({violationTypeStatusQueueJumping: false});
        await this.setState({violationTypeStatusRedLight: false});
        await this.setState({violationTypeStatusTrespassZebra: false});
        await this.setState({violationTypeStatusWrongTurn: false});
        await this.setState({violationTypeStatusWrongWay: false});
        await this.setState({violationTypeStatusSeatBelt: false});
        await this.setState({violationTypeStatusCellphone: false});
        await this.setState({violationTypeStatusSpeed: false});
        await this.setState({violationTypeStatusSpotSpeed: false});

        this.callApiWithFilters();
    }
    async violationTypeCheckingSeatBelt() {
        await this.setState({violationTypeStatusSeatBelt: !this.state.violationTypeStatusSeatBelt});
        await this.setState({violationTypeStatusAll: false});

        this.callApiWithFilters();
    }
    async violationTypeCheckingCellphone() {
        await this.setState({violationTypeStatusCellphone: !this.state.violationTypeStatusCellphone});
        await this.setState({violationTypeStatusAll: false});

        this.callApiWithFilters();
    }

    async violationTypeCheckingQueueJumping() {
        await this.setState({violationTypeStatusQueueJumping: !this.state.violationTypeStatusQueueJumping});
        await this.setState({violationTypeStatusAll: false});

        this.callApiWithFilters();
    }

    async violationTypeCheckingRedLight() {
        await this.setState({violationTypeStatusRedLight: !this.state.violationTypeStatusRedLight});
        await this.setState({violationTypeStatusAll: false});

        this.callApiWithFilters();
    }

    async violationTypeCheckingTrespassZebra() {
        await this.setState({violationTypeStatusTrespassZebra: !this.state.violationTypeStatusTrespassZebra});
        await this.setState({violationTypeStatusAll: false});

        this.callApiWithFilters();
    }
    async violationTypeCheckingWrongTurn() {
        await this.setState({violationTypeStatusWrongTurn: !this.state.violationTypeStatusWrongTurn});
        await this.setState({violationTypeStatusAll: false});

        this.callApiWithFilters();
    }
    async violationTypeCheckingWrongWay() {
        await this.setState({violationTypeStatusWrongWay: !this.state.violationTypeStatusWrongWay});
        await this.setState({violationTypeStatusAll: false});

        this.callApiWithFilters();
    }
    async violationTypeCheckingSpeed() {
        await this.setState({violationTypeStatusSpeed: !this.state.violationTypeStatusSpeed});
        await this.setState({violationTypeStatusAll: false});

        this.callApiWithFilters();
    }
    async violationTypeCheckingSpotSpeed() {
        await this.setState({violationTypeStatusSpotSpeed: !this.state.violationTypeStatusSpotSpeed});
        await this.setState({violationTypeStatusAll: false});

        this.callApiWithFilters();
    }
    componentDidUpdate(){
        if(this.state.prevPage !== this.state.currPage){
           
            setTimeout( () => {this.currPageChanged()}, 1); 
            let currentPage = this.state.currPage;
            this.setState({prevPage: currentPage})
        }
       
    }

    render() {
        window.localStorage['pageNo'] = this.state.currPage;

        return (
               
            <Data
                timeFilterChanged={this.timeFilterChanged}
                violationsCountChanged = {this.violationsCountChanged}
                ViolationDetailStatus={this.state.violationDetailStatus}
                viewSelectedViolation={this.viewSelectedViolation}
                ViolationTypeCheckingAll={this.violationTypeCheckingAll}
                ViolationTypeCheckingSeatBelt={this.violationTypeCheckingSeatBelt}
                ViolationTypeCheckingCellphone={this.violationTypeCheckingCellphone}
                ViolationTypeCheckingQueneJumping={this.violationTypeCheckingQueueJumping}
                ViolationTypeCheckingRedLight={this.violationTypeCheckingRedLight}
                ViolationTypeCheckingTrespassZebra={this.violationTypeCheckingTrespassZebra}
                ViolationTypeCheckingWrongTurn={this.violationTypeCheckingWrongTurn}
                ViolationTypeCheckingWrongWay={this.violationTypeCheckingWrongWay}
                ViolationTypeCheckingSpeed={this.violationTypeCheckingSpeed}
                ViolationTypeCheckingSpotSpeed={this.violationTypeCheckingSpotSpeed}
                ViolationTypeStatusAll={this.state.violationTypeStatusAll}
                ViolationTypeStatusSeatBelt={this.state.violationTypeStatusSeatBelt}
                ViolationTypeStatusCellphone={this.state.violationTypeStatusCellphone}
                ViolationTypeStatusQueneJumping={this.state.violationTypeStatusQueueJumping}
                ViolationTypeStatusRedLight={this.state.violationTypeStatusRedLight}
                ViolationTypeStatusTrespassZebra={this.state.violationTypeStatusTrespassZebra}
                ViolationTypeStatusWrongTurn={this.state.violationTypeStatusWrongTurn}
                ViolationTypeStatusWrongWay={this.state.violationTypeStatusWrongWay}
                ViolationTypeStatusSpeed={this.state.violationTypeStatusSpeed}
                ViolationTypeStatusSpotSpeed={this.state.violationTypeStatusSpotSpeed}
            />
        )
    }
    
});


// WEBPACK FOOTER //
// ./src/components/ViolationsHistory/ViolationsHistory.tsx